export const gameAttributeHasHistory = (gameAttribute: any) => {
	return (
		Array.isArray(gameAttribute) &&
		gameAttribute.length > 0 &&
		gameAttribute[0] &&
		// Legacy JSON-encoded history used null where runtime state used -Infinity.
		(typeof gameAttribute[0].start === "number" ||
			gameAttribute[0].start === null)
	);
};
